import { Component,  OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators,ValidationErrors,AsyncValidatorFn,AbstractControl} from '@angular/forms';
import { Observable, Subscription, filter , of} from 'rxjs';
import { debounceTime, map, startWith, switchMap,catchError } from 'rxjs/operators';
import { OrganizationService } from 'src/app/internal-user/customer-management/services/organization.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as constants from 'src/app/config/app-constants';
import { MatTableDataSource } from '@angular/material/table';
import { Inject } from '@angular/core';
import { SalesforceService } from '../../services/salesforce.service';
import { OrgRole } from 'src/app/common/user/models/org-role';
import { SiteInfo } from '../../models/org-with-admin-user';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { AuthorizationService } from '../../services/authorization.service';
import { AddOrganizationDialogComponent } from '../add-organization/add-organization-dialog.component';
import { Role } from 'src/app/common/permission-groups/models/role';
import { PermissionGroupsService } from 'src/app/common/permission-groups/services/permission-groups.service';
import { AutoCompleteDropDownValidators } from 'src/app/shared/directives/validate-selectedvalue-in-collection';
import { AutoCompleteField } from 'src/app/shared/models/auto-complete-field';
import { LaunchDarklyService } from 'src/app/shared/services/launch-darkly.service';
import { IncadaLocation } from '../../models/incada-location';
import { Organization } from '../../models/organization';

@Component({
    selector: 'app-add-site-dialog',
    templateUrl: './add-site-dialog.component.html',
    styleUrls: ['./add-site-dialog.component.scss'],
    standalone: false
})

export class AddSiteDialogComponent implements OnInit, OnDestroy {

  constructor(
    public dialogRef: MatDialogRef<AddSiteDialogComponent>,
    public dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService,
    private toastService: ToastService,
    private organizationService: OrganizationService,
    private salesforceService: SalesforceService,
    private authorizationService: AuthorizationService,
    private permissionGroupService : PermissionGroupsService,
    private launchDarklyService: LaunchDarklyService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.userdataSource = new MatTableDataSource();
  }
  userdisplayedColumns = ['name', 'email', 'role', 'delete'];
  userdataSource: MatTableDataSource<SiteInfo>;

  // recent search dummy data
  displayedColumns: string[] = ['name'];
  showbackbutton = false;
  isAddNewUserSelected=false;
  isparentnotassociated = false;  
  options: any[];

  siteOptions: any[];
  siteOptionswithfilter: any[] = []; 
  existingSites: any[];
  filteredOptions: Observable<any[]>;
  permissionGroups: Role[] = [];
  parentOrgName: string;
  parentOrgId: string;
  filter: string;
  minLengthToSearch = 3;
  siteSalesforceId: string;
  siteSalesforceName: string;
  siteCustomerNumber: string;
  isCustomerreload = false;
  isEmailExist = false;
  isSiteExist = false;

  isNoOrgResult=false;

  // Incada integration
  showIncadaControls = false;
  private incadaFlagEnabled = false;
  private parentOrg: Organization | null = null;
  parentIncadaTenantSlug = '';
  parentIncadaRegionSlug = '';
  private selectedIncadaSite: IncadaLocation | null = null;
  private selectedIncadaOrgUnit: IncadaLocation | null = null;
  private flagSubscription: Subscription;

  // placeholder
  myplaceHolder: string;

  formGroup: FormGroup = new FormGroup({
    siteName: new FormControl('', [Validators.required]),
    salesforceName: new FormControl('', [Validators.required, AutoCompleteDropDownValidators.SelectedValueValidator(this.siteOptionswithfilter, AutoCompleteField.salesforce)]),
    user: new FormGroup({
      userLastName: new FormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern('[a-zA-Z]+([-\' ][a-zA-Z]+)*')]),
      userFirstName: new FormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern('[a-zA-Z]+([-\' ][a-zA-Z]+)*')]),
      permissionGroup: new FormControl('', [Validators.required]),    
      userEmail: new FormControl('', [Validators.pattern('^[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'), Validators.required])
    })
  });

  parentOrgformGroup: FormGroup = new FormGroup({
    parentName: new FormControl('', [Validators.required]),
  });

  @ViewChild('autoCompleteInput', { static: false,read: MatAutocompleteTrigger })  trigger: MatAutocompleteTrigger;

  ngOnInit() {
    this.formGroup.controls.salesforceName.valueChanges.pipe(
      switchMap(id => {
        if (id.length > 2)
          return this.salesforceService.getSitesByNameOrCustomerNo(id);
        else
          return this.siteOptionswithfilter = [];
      })
    ).subscribe(res => { 
      res = this.disableExistingSites(res);
      this.siteOptionswithfilter = res;
      this.resetSalesforceValidators();
    },
      (error) => {
        //Error callback
        this.siteOptionswithfilter = [];
        this.resetSalesforceValidators();
        this.toastService.openToast("No sites found", constants.ToastPanelType.error);
      });
    this.isparentnotassociated = this.data.isparentnotassociated;
    this.parentOrgName = this.data.parentName;
    this.parentOrgId=this.data.parentID;
    this.ngxLoader.start('site-dialog-load');
    this.loadParentOrg();
    if(!this.isparentnotassociated){
      this.loadAllSites();
    }
    this.loadPermissionGroups();
    this.toggleUserFormGroup();

    this.flagSubscription = this.launchDarklyService.flagChange.subscribe((flags) => {
      this.incadaFlagEnabled = flags['release-incada'] ?? false;
      this.evaluateIncadaVisibility();
    });
  }

  ngOnDestroy() {
    if (this.flagSubscription) {
      this.flagSubscription.unsubscribe();
    }
  }

  private evaluateIncadaVisibility() {
    const isIncadaOrg = !!(this.parentOrg?.incadaSlug);
    const shouldShow = this.incadaFlagEnabled && isIncadaOrg;

    if (shouldShow && !this.showIncadaControls) {
      this.showIncadaControls = true;
      this.parentIncadaTenantSlug = this.parentOrg.incadaSlug;
      this.parentIncadaRegionSlug = this.parentOrg.incadaRegion || '';
      this.formGroup.addControl('incadaSite', new FormControl('', [Validators.required]));
      this.formGroup.addControl('incadaOrgUnit', new FormControl(''));
      this.selectedIncadaSite = null;
      this.selectedIncadaOrgUnit = null;
    } else if (!shouldShow && this.showIncadaControls) {
      this.showIncadaControls = false;
      this.formGroup.removeControl('incadaSite');
      this.formGroup.removeControl('incadaOrgUnit');
      this.selectedIncadaSite = null;
      this.selectedIncadaOrgUnit = null;
    }
  }

  onIncadaSiteSelected(location: IncadaLocation | null) {
    this.selectedIncadaSite = location;
  }

  onIncadaOrgUnitSelected(location: IncadaLocation | null) {
    this.selectedIncadaOrgUnit = location;
  }

  
toggleUserFormGroup() {  
  this.isAddNewUserSelected = !this.isAddNewUserSelected;
  const userGroup = this.formGroup.get('user');
  if (!this.isAddNewUserSelected) {    
    (this.formGroup.get('user') as FormGroup).reset();
    this.isEmailExist = false;
    userGroup?.disable();
  } else {
    userGroup?.enable();
  }
}


  resetSalesforceValidators() {
      this.formGroup.controls.salesforceName.clearValidators();      
      this.formGroup.controls.salesforceName.setValidators([Validators.required, AutoCompleteDropDownValidators.SelectedValueValidator(this.siteOptionswithfilter, AutoCompleteField.salesforce)]);      
  }

  loadAllSites(){
    this.organizationService.getSites()
      .subscribe((sites) => {
        this.existingSites = sites;
      }, () => {
      });

  }

  showsite(value) {
    if ((document.getElementById('parentName') as HTMLInputElement).value=== '') {
      this.toastService.openToast('Parent Organization cannot be empty', constants.ToastPanelType.error);
    }
    else {
      this.isparentnotassociated = false;
      this.showbackbutton = value;
      this.parentOrgName = (document.getElementById('parentName') as HTMLInputElement).value;

    }
  }

  hidesite() {
    this.isparentnotassociated = true;
  }

  validateForm() {
    if (this.formGroup.invalid) {
       this.formGroup.get('siteName').markAsTouched();
       this.formGroup.get('salesforceName').markAsTouched();
       this.formGroup.get('user.userLastName').markAsTouched();
       this.formGroup.get('user.userFirstName').markAsTouched();
       this.formGroup.get('user.permissionGroup').markAsTouched();
       this.formGroup.get('user.userEmail').markAsTouched();
       return;
    }
 }

  // Adds new site with admin user.
  addRow() {

    if (!this.formGroup.valid)
    {
      this.validateForm();
      return;
    }

    if(this.isEmailExist){
      const loadingKey = 'Email already exists!';
      this.toastService.stopLoadingAndShowError(
        'Email already exists!', loadingKey);
    }
    else{
      const siteInfo: SiteInfo = this.formGroup.getRawValue();
      siteInfo.parentOrgID = this.parentOrgId;
      siteInfo.siteSalesforceName = this.siteSalesforceName;
      siteInfo.siteSalesforceId = this.siteSalesforceId;
      siteInfo.siteCustomerNo = this.siteCustomerNumber;
      siteInfo.isAddNewUser = this.isAddNewUserSelected;

      if (this.showIncadaControls) {
        if (this.selectedIncadaSite) {
          siteInfo.incadaSiteId = this.selectedIncadaSite.id;
          siteInfo.incadaSiteSlug = this.selectedIncadaSite.identifier;
          siteInfo.incadaSiteName = this.selectedIncadaSite.name;
        }
        if (this.selectedIncadaOrgUnit) {
          siteInfo.incadaOrgUnitId = this.selectedIncadaOrgUnit.id;
          siteInfo.incadaOrgUnitSlug = this.selectedIncadaOrgUnit.identifier;
          siteInfo.incadaOrgUnitName = this.selectedIncadaOrgUnit.name;
        }
      }

      this.ngxLoader.start('add-site-submit');
      if(this.isAddNewUserSelected){        
        siteInfo.roleID = this.formGroup.get('user.permissionGroup').value;
        siteInfo.userEmail = this.formGroup.get('user.userEmail').value;
        siteInfo.userFirstName = this.formGroup.get('user.userFirstName').value;
        siteInfo.userLastName = this.formGroup.get('user.userLastName').value;  
        this.organizationService.createSiteWithAdminUser(siteInfo).subscribe({
          next: () => {
            this.SaveSuccessful();
          },
          error: ({ error }) => {
            this.isCustomerreload = false;
            this.ngxLoader.stop('add-site-submit');
            const errorMessage = error || 'Unable to create site!';
            this.toastService.openToast(errorMessage, constants.ToastPanelType.error);
          }
        });
      } else {
        this.organizationService.createSiteWithoutUser(siteInfo).subscribe({
          next: () => {
            this.SaveSuccessful();
          },
          error: ({ error }) => {
            this.isCustomerreload = false;
            this.ngxLoader.stop('add-site-submit');
            const errorMessage = error || 'Unable to create site!';
            this.toastService.openToast(errorMessage, constants.ToastPanelType.error);
          }
        });
      }      
    }
  }

  SaveSuccessful() {
    this.ngxLoader.stop('add-site-submit');
    this.dialogRef.close('success');
    setTimeout(() => {
      this.toastService.openToast('New Site Created', constants.ToastPanelType.done);
    }, 700);
  }

  deleterow(value) {
    const index = value.currentTarget.id;
    this.userdataSource.data.splice(index, 1);
    this.userdataSource.data = this.userdataSource.data;
  }

  loadPermissionGroups() {
    this.permissionGroupService.getDefaultPermissionGroups()
      .subscribe((response) => {
        // New site needs only Admin permission group
        // Filter only permission groups where the 'description' property is exactly 'Admin'
        this.permissionGroups = response.filter(x => x.description === 'Admin');
        this.ngxLoader.stop('site-dialog-load');
      }, (response) => this.toastService.stopLoadingAndShowError(response,
        'Unable to load permission groups!', 'site-dialog-load'));
  }

  loadParentOrg() {
    this.organizationService.getParentOrganizations()
      .subscribe((organizations) => {
        this.options = organizations;
        this.filteredOptions = this.parentOrgformGroup.controls.parentName.valueChanges
          .pipe( 
            startWith(''),
            map(value => typeof value === 'string' ? value : value.name),
            map(name => name ? this._filter(name) : this.options.slice())
          );

        // If parent org is already known, resolve it for Incada evaluation
        if (this.parentOrgId && !this.parentOrg) {
          this.parentOrg = organizations.find(o => o.organizationId === this.parentOrgId) || null;
          this.evaluateIncadaVisibility();
        }

        this.ngxLoader.stop('site-dialog-load');;
      }, () => {
        this.ngxLoader.stop('site-dialog-load');;
        this.toastService.openToast('Error while loading organizations!', constants.ToastPanelType.error);
      });
  }

  private _filter(name: string) {
    this.isNoOrgResult=false;
    const filterValue = name.toLowerCase();
    const filterResult =this.options.filter(option => option.name.toLowerCase().includes(filterValue));
    this.isNoOrgResult = !(filterResult && filterResult.length>0);
    return filterResult;
  }

  fetchSalesforceDetails(siteDetail) {
    this.siteSalesforceId = siteDetail.id;
    this.siteSalesforceName = siteDetail.name;
    this.siteCustomerNumber = siteDetail.customer_Num__c;
  }

  clear(ctrl){
    ctrl.setValue('');
  }
  onBlur(){
    setTimeout(() => {
      this.formGroup.get('salesforceName').setValue((this.siteSalesforceId != null && this.siteSalesforceId != undefined)? this.siteSalesforceId : '');
    }, 200);
  }

  onParentOrgBlur(){
    setTimeout(() => {
      this.parentOrgformGroup.get('parentName').setValue((this.parentOrgId != null && this.parentOrgId != '')? this.parentOrgformGroup.get('parentName').value : '');
    }, 200);
  }

  emailExist() {
    this.authorizationService.checkUserExists(this.formGroup.get('user.userEmail').value)
      .subscribe((response) => {
        if (response == true) {
          this.isEmailExist = true;
        }
        else {
          this.isEmailExist = false;
        }
      }, (error) => {
        this.toastService.openToast('Error while checking email exists!', constants.ToastPanelType.error);
        this.isEmailExist = false;
      });
  }

  fetchParentOrgDetails(orgDetail) {
   
    this.parentOrgId = orgDetail.organizationId;
    this.parentOrg = orgDetail;
    this.evaluateIncadaVisibility();
    this.loadAllSites();


  }

  getSiteName(value: any) {
    if (value !== '') {
      const site = this.siteOptionswithfilter.find(org => org.id === value);
      return site != null ? site.name : '';
    }
    else {
      return '';
    }
  }

  disableExistingSites(assets) {
    assets?.forEach((element) => {
      const system = this.existingSites?.find(site => site.salesforceId === element.id);
      if(system != null) {
        element.isOnboarded = true;
      }
      else {
        element.isOnboarded = false;
      }
    });
    return assets;    
  }

  openOrgWin()
  {
    this.dialogRef.close('openorg');
  }

  getSalesforceErrorMessage() {            
    if (this.siteOptionswithfilter == null || this.siteOptionswithfilter.length == 0) {
      return "No Site Name retrieved from salesforce";
    } else if (this.formGroup.get('salesforceName').hasError('required')) {
      return "Site Name required";      
    } else if (this.formGroup.get('salesforceName').hasError('ShowValidatonError')) {
      return "Site Name is invalid";
    } else {
      return null;
    }
  }
}
